const API_HOST = process.env.REACT_APP_API_HOST;

const postJson = async (path, payload, options = {}) => {
  const response = await fetch(`${API_HOST}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload || {}),
    signal: options.signal,
  });

  const result = await response.json();
  if (!result?.success) {
    throw new Error(result?.message || "Failed to fetch bets");
  }
  return result.data;
};

export const fetchBetList = (payload, options) =>
  postJson("/getBetsList", payload, options);

export const fetchBetFilterValues = (column, search = "", options) =>
  postJson("/getBetFilterValues", { column, search }, options);

export const fetchBetFilterOptions = () => postJson("/getBetFilterOptions", {});

export const toColumnFilters = (filters = [], filterFns = {}) =>
  filters
    .filter((filter) => {
      if (filter?.value == null || filter.value === "") return false;
      if (Array.isArray(filter.value) && filter.value.length === 0) return false;
      return true;
    })
    .map((filter) => ({
      id: filter.id,
      value: filter.value,
      mode: filterFns[filter.id] || (Array.isArray(filter.value) ? "in" : "contains"),
    }));

export const toAgGridColumnFilters = (filterModel = {}) =>
  Object.entries(filterModel)
    .map(([id, model]) => {
      if (Array.isArray(model?.values) && model.values.length > 0) {
        return { id, value: model.values, mode: "in" };
      }
      if (model?.filter != null && model.filter !== "") {
        return { id, value: model.filter, mode: "contains" };
      }
      return null;
    })
    .filter(Boolean);
